<template>
  <button
    :class="classList"
    :name="name"
    @click="handleClick"
    :type="type"
    :disabled="props.disabled"
  >
    <template v-if="isLoading === true">
      <div class="btn__loader"><i class="icon-spinner9 spinner"/></div>
    </template>
    <div class="btn__content" :class="contentClass">
      <slot/>
    </div>
  </button>
</template>

<script setup>
  import { clearTimeout, setTimeout } from '@/utils/global';
  import { ref, watch, computed } from 'vue';

  const props = defineProps({
    type: {
      type: String,
      default: 'button',
    },
    loading: {
      type: Boolean,
      default: null,
    },
    contentClass: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    name: {
      type: String,
      default: null,
    },
  });

  const emit = defineEmits(['click']);
  const isLoading = ref(false);
  const timeout = ref(null);

  const classList = computed(() => {
    const list = [];

    if (props.loading !== null) {
      list.push('btn--has-loader');

      if (props.loading) {
        list.push('btn--loading');
      }
    }

    return ['btn', ...list];
  });

  watch(() => props.loading, (newValue) => {
    if (newValue) {
      timeout.value = setTimeout(() => {
        isLoading.value = true;
      }, 200);
    } else {
      if (timeout.value) {
        clearTimeout(timeout.value);
        timeout.value = null;
      }

      isLoading.value = false;
    }
  }, { immediate: true });

  function handleClick(event) {
    if (props.disabled) {
      event.preventDefault();
      return;
    }

    emit('click', event);
  }
</script>
